import {dataset, datasetsEnums} from "../../../interfaces/chart.interfaces";
import moment from "moment";
import {IBaseTagMetric} from "@leap4/entities-discrepancy-common/src/interfaces/baseTagMetric.interface";
import {EntitiesProperties} from "../../../utils/enums";
import {DateTime} from "luxon";

export enum TimeDisplayInterval {
    Daily = 'daily',
}

export const TimeDisplay = [
    {name: 'Daily', value: TimeDisplayInterval.Daily},
]

export function getDefaultTimeDisplay(startDate: string, endDate: string): number {
    return startDate === endDate ? 1 : 0
}

export function indexToTimeInterval(index: number): TimeDisplayInterval {
    return TimeDisplay[index].value
}

export function getValuesByMetricForIntervalType(transactions: IBaseTagMetric[], selectedMetric: string, isOneDay: boolean): any[] {
    let valuesByMetric = transactions?.map((x: IBaseTagMetric) => {
        if (selectedMetric === EntitiesProperties.NUMERIC.ALL.PROFIT) return x.revenue - x["cost"];
        return x[selectedMetric];
    })
    if (isOneDay) {
        let highestUntilNow = 0
        valuesByMetric = valuesByMetric.map((currentValue, index, currArray) => {
            const valueBefore = index === 0 ? 0 : currArray[index - 1];
            if (valueBefore > highestUntilNow) {
                highestUntilNow = valueBefore
            }
            return Math.max(currentValue - highestUntilNow, 0)
        })
    }
    return valuesByMetric
}


export function getXAxisFormatFunc(startDate: string, endDate: string): any {
    if (startDate === endDate) {
        return (timestamp) => moment(roundDate(new Date(timestamp))).utc().format("HH:mm")
        return (timestamp) => moment(roundDate(new Date(timestamp))).utc().format("DD/MM")
    }
}
export function getLabelsForGraph(s: string, e: string): any[] {
    if (e===s) {
        const startDate = DateTime.fromJSDate(new Date(s)).toUTC().startOf("day")
        const endDate = DateTime.fromJSDate(new Date(e)).plus({day: 1}).toUTC().startOf("day")
        let currentDate = startDate;
        const ans = []
        while (currentDate <= endDate) {
            ans.push(currentDate.toJSDate().toString())
            currentDate = currentDate.plus({minute: 30})
        }
        return ans;
    } else {
        const startDate = DateTime.fromJSDate(new Date(s)).endOf("day").toUTC()
        let endDate = DateTime.fromJSDate(new Date(e)).endOf("day").toUTC();
        if(endDate.toISODate() === DateTime.now().toUTC().toISODate()){
            endDate = endDate.minus({day: 1})
        }
        let currentDate = startDate;
        const ans = []
        while (currentDate <= endDate) {
            ans.push(currentDate)
            currentDate = currentDate.plus({day: 1})
        }
        return ans;
    }
}

export function roundDate(date: Date): Date {
    const minutes = 30;
    const ms = 1000 * 60 * minutes;

    // 👇️ replace Math.round with Math.ceil to always round UP
    return new Date(Math.round(date.getTime() / ms) * ms);
}


export function getDatasetsForGraph(allValues, metric, isOneDay: boolean): Array<dataset> {
    let values = []
    values = getValuesByMetricForIntervalType(allValues?.data? allValues.data?.map(x => x.totals) : [], metric, isOneDay)
    let selectedDatesDataset: dataset = {labelName: 'Selected Dates', values, backgroundColor: null}
    return [selectedDatesDataset]
}



